unit UPictureModel;

interface

uses
  UEssentialHelper, UResultModel, Js;

type
  TPictureModel = class
  private
    FPictureData: string;
    FComment: string;
    FPersonalNr: string;
    FFak: string;
    FOnConfirmation: TCallback;
    FOnError: TErrorEvent;
    FResult: TResultModel;
    FCreated: TDateTime;
    procedure ClearValues;
    procedure DoConfirmation;
    procedure DoErrorHandling(AMsg: string);
    procedure SetValues(Json: string); overload;
    procedure SetValues(Obj: TJsObject); overload;
    procedure SetComment(const Value: string);
    procedure SetFak(const Value: string);
    procedure SetPersonalNr(const Value: string);
    procedure SetPictureData(const Value: string);
    procedure SetOnConfirmation(const Value: TCallback);
    procedure SetOnError(const Value: TErrorEvent);
    procedure SetResult(const Value: TResultModel);
    procedure SetCreated(const Value: TDateTime);
  public
    constructor Create; overload;
    constructor Create(Json: string); overload;
    function ToJson: string;
    function ToString: string; override;
    procedure Insert(Url: string);
    property PersonalNr: string read FPersonalNr write SetPersonalNr;
    property Fak: string read FFak write SetFak;
    property PictureData: string read FPictureData write SetPictureData;
    property Comment: string read FComment write SetComment;
    property OnConfirmation: TCallback read FOnConfirmation
      write SetOnConfirmation;
    property OnError: TErrorEvent read FOnError write SetOnError;
    property Result: TResultModel read FResult write SetResult;
    property Created: TDateTime read FCreated write SetCreated;
  end;

implementation

uses
  WebLib.Json, WebLib.REST, WebLib.Controls, System.SysUtils;

{ TPictureModel }

procedure TPictureModel.ClearValues;
begin
  Self.PersonalNr := '';
  Self.Fak := '';
  Self.PictureData := '';
  Self.Comment := '';
  Self.Created := 0;
end;

constructor TPictureModel.Create;
begin
  Self.OnConfirmation := nil;
  Self.OnError := nil;
  Self.Result := nil;
  Self.ClearValues;
end;

constructor TPictureModel.Create(Json: string);
begin
  Self.OnConfirmation := nil;
  Self.OnError := nil;
  Self.Result := nil;
  Self.SetValues(Json);
end;

procedure TPictureModel.DoConfirmation;
begin
  if Assigned(Self.OnConfirmation) then
    Self.OnConfirmation(Self);
end;

procedure TPictureModel.DoErrorHandling(AMsg: string);
begin
  if Assigned(Self.OnError) then
    Self.OnError(Self, AMsg);
end;

procedure TPictureModel.Insert(Url: string);
var
  client: TRestClient;
  Obj: TJsonObject;
  s: string;
  procedure Response(sender: TObject; aResponse: string);
  begin
    Self.Result := TResultModel.Create(aResponse);
    Self.DoConfirmation;
  end;

  procedure ErrorHandler(sender: TObject; ARequest: TJSXMLHttpRequestRecord;
    Event: TJSEventRecord; var Handled: Boolean);
  begin
    Handled := true;
    Self.DoErrorHandling('TPictureModel.Insert fehlgeschlagen');
  end;

begin
  Obj := TJsonObject.Create;
  Obj.AddPair('value', Self.ToJson);
  s := Obj.ToString;
  client := TRestClient.Create(nil);
  client.OnResponse := Response;
  client.OnError := ErrorHandler;
  client.HttpsPost(Url + '/PictureService/Insert', 'application/json', s);
  Obj.Free;
end;

procedure TPictureModel.SetComment(const Value: string);
begin
  FComment := Value;
end;

procedure TPictureModel.SetCreated(const Value: TDateTime);
begin
  FCreated := Value;
end;

procedure TPictureModel.SetFak(const Value: string);
begin
  FFak := Value;
end;

procedure TPictureModel.SetOnConfirmation(const Value: TCallback);
begin
  FOnConfirmation := Value;
end;

procedure TPictureModel.SetOnError(const Value: TErrorEvent);
begin
  FOnError := Value;
end;

procedure TPictureModel.SetPersonalNr(const Value: string);
begin
  FPersonalNr := Value;
end;

procedure TPictureModel.SetPictureData(const Value: string);
begin
  FPictureData := Value;
end;

procedure TPictureModel.SetResult(const Value: TResultModel);
begin
  FResult := Value;
end;

procedure TPictureModel.SetValues(Obj: TJsObject);
begin
  Self.ClearValues;
  if Obj['PersonalNr'] <> nil then
    Self.PersonalNr := string(Obj['PersonalNr']);
  if Obj['Fak'] <> nil then
    Self.Fak := string(Obj['Fak']);
  if Obj['PictureData'] <> nil then
    Self.PictureData := string(Obj['PictureData']);
  if Obj['Comment'] <> nil then
    Self.Comment := string(Obj['Comment']);
  if Obj['Created'] <> nil then
    Self.Created := StrToDateTime(string(Obj['Created']));
end;

procedure TPictureModel.SetValues(Json: string);
var
  Obj: TJsObject;
begin
  Obj := TJsJson.parseObject(Json);
  Self.SetValues(Obj);
end;

function TPictureModel.ToJson: string;
var
  Obj: TJsonObject;
begin
  Obj := TJsonObject.Create;
  Obj.AddPair('PersonalNr', Self.PersonalNr);
  Obj.AddPair('Fak', Self.Fak);
  Obj.AddPair('PictureData', Self.PictureData);
  Obj.AddPair('Comment', Self.Comment);
  Obj.AddPair('Created', DateTimeToStr(Self.Created));
  Result := Obj.ToJson;
  Obj.Free;
end;

function TPictureModel.ToString: string;
begin
  Result := 'Bild zu Auftrag ' + Self.Fak;
end;

end.
